import { usePatchSearchCache } from "@/hooks/mutations";
import { useWorkbookId } from "@/hooks/use-workbook";
import { useMappingStore } from "@/stores/mapping";

export const useExtendForm = () => {
  const { data: workbookId } = useWorkbookId();
  const {
    parent,
    setParent,
    role,
    setRole,
    type,
    address,
    childInfo,
    setChildInfo,
    clearExtend,
    extendingChild,
    setExtendingChild,
  } = useMappingStore((state) => state.extend);

  const {
    mutate: patchSearchCache,
    mutateAsync: patchSearchCacheAsync,
    ready,
  } = usePatchSearchCache({ useInvalidateQueries: false });

  return {
    workbookId,
    parent,
    setParent,
    role,
    setRole,
    type,
    address,
    childInfo,
    clearExtend,
    setChildInfo,
    patchSearchCache,
    patchSearchCacheAsync,
    ready,
    extendingChild,
    setExtendingChild,
  };
};
